export const bp_jacket = {
  msrp: 54.99,
  variants: [['hoodie', 'no hood']],
  infoLink: 'https://www.teamtriton.com/bp-jacket.html',
  items: [
    {
      number: 'BPJ099',
      hasModel: false,
    },
    {
      number: 'BPJ100',
      hasModel: false,
    },
    {
      number: 'BPJ101',
      hasModel: false,
    },
    {
      number: 'BPJ102',
      hasModel: false,
    },
    {
      number: 'BPJ103',
      hasModel: false,
    },
    {
      number: 'BPJ104',
      hasModel: false,
    },
    {
      number: 'BPJ105',
      hasModel: false,
    },
    {
      number: 'BPJ106',
      hasModel: false,
    },
    {
      number: 'BPJ107',
      hasModel: false,
    },
    {
      number: 'BPJ108',
      hasModel: false,
    },
    {
      number: 'BPJ109',
      hasModel: false,
    },
    {
      number: 'BPJ110',
      hasModel: false,
    },
    {
      number: 'BPJ111',
      hasModel: false,
    },
    {
      number: 'BPJ112',
      hasModel: false,
    },
  ],
};
